/**
 *  PhysicsActor
 *
 *  Created by Legman on 22/02/2017.
 *
 */

import Common       from "./Common";
import GummyBear    from "./GummyBear";
import PhysicsActor from "./PhysicsActor";

/**
 * @class
 */
export default class Monkey extends PhysicsActor {
    constructor() {
        super();

        const assets = Common.assets;

        /**
         * @member {number}
         */
        this.towerY = 0;

        /**
         * @member {boolean}
         */
        this.onTop = true;

        this.view = new PIXI.spine.Spine(assets.getSpineData("steve"));
        this.view.position.set(10, 70);
        this.view.scale.set(0.5, 0.5);
        this.view.skeleton.setToSetupPose();
        this.view.skeleton.setSkin(null);
        this.view.autoUpdate = false;
        this.view.state.addListener({complete: this.onAnimationComplete.bind(this)});
        this.view.update(0);
        this.addChild(this.view);

        /**
         * @member {Array.<string>}
         * @private
         */
        this._idleAnimationNames = [
            "idle_bored",
            "idle_bum",
            "idle_gorilla",
            "idle_jig",
            "idle_look_down",
            "idle_look_left",
            "idle_look_right",
            "idle_look_up",
            "idle_nose",
            "idle_wink"
        ];

        /**
         * @member {Array.<string>}
         * @private
         */
        this._topAnimationNames = [
            "top_idle_look",
            "top_idle_scratch",
            "top_idle_smile",
            "top_idle_wave"
        ];

        /**
         * @member {Array.<string>}
         * @private
         */
        this._hitAnimationNames = [
            "hit_001",
            "hit_002",
            "hit_003",
            "hit_004",
            "hit_005",
            "hit_006",
            "hit_007",
            "hit_008",
            "hit_009",
            "hit_010"
        ];

        /**
         * @member {Array.<string>}
         * @private
         */
        this._spawnAnimationNames = [
            "top_spawn_001",
            "top_spawn_002"
        ];

        /**
         * @member {Array}
         * @private
         */
        this._landAnimationNames = [
            "top_land"
        ];
    }

    init() {
        super.init();

        this.playIdleState(this.onTop);
    }

    update() {
        super.update();

        // view is visible when in the viewport
        const y = this.y - Common.camera.position.y;
        const height = p3.View.height * 1.2;
        this.view.visible = y > (Common.STAGE_HEIGHT - height) * 0.5 && y < (Common.STAGE_HEIGHT + height) * 0.5;

        // only update the animation when the monkeys are visible
        if (this.view.visible) {
            this.spine.update(deltaTime);
        }
    }

    /**
     * @returns {p2.Body}
     */
    createBody() {
        const body = new p2.Body({mass: 1.0});
        body.type = p2.Body.DYNAMIC;
        body.allowSleep = true;
        body.sleepSpeedLimit = 4.0;
        body.parent = this;

        const shape = new p2.Box({width: 134, height: 142});
        shape.collisionGroup = PhysicsActor.DEFAULT;
        shape.collisionMask = PhysicsActor.DEFAULT | PhysicsActor.GUMMY_BEAR;
        shape.material = PhysicsActor.MATERIAL_DEFAULT;

        body.addShape(shape);
        return body;
    }

    /**
     * @param {boolean} [top]
     * @returns {string}
     */
    playIdleState(top) {
        const arr = top ? this._topAnimationNames : this._idleAnimationNames;
        const animationName = arr[Math.floor(Math.random() * arr.length)];
        this.spine.state.setAnimation(0, animationName, false);
        return animationName;
    }

    /**
     * @param {boolean} [top]
     * @returns {string}
     */
    playHitState(top) {
        const arr = top ? this._landAnimationNames : this._hitAnimationNames;
        const animationName = arr[Math.floor(Math.random() * arr.length)];
        this.spine.state.setAnimation(0, animationName, false);
        return animationName;
    }

    /**
     * @returns {string}
     */
    playSpawnState() {
        const animationName = this._spawnAnimationNames[Math.floor(Math.random() * this._spawnAnimationNames.length)];
        this.spine.state.setAnimation(0, animationName, true);
        return animationName;
    }

    playOuchSFX() {
        if (this.onTop) {
            const velocity = new p3.Vector2(this.body.velocity[0], this.body.velocity[1]);
            if (velocity.lengthSq > 100) {
                Common.audio.playSound("sfx_steve_ouch_00");
            }
        } else {
            if (Math.random() < 0.25) {
                delay(function() {
                    Common.audio.playSound("sfx_steve_ouch_00");
                }, 0.1 + Math.random() * 0.2, this);
            }
        }
    }

    /**
     * @param {p2.Body} [body]
     */
    onBeginContact(body) {
        if (body.parent instanceof GummyBear) return;

        super.onBeginContact(body);

        this.playHitState(this.onTop);
        this.playOuchSFX();
    }

    /**
     * @param {p2.Body} [body]
     */
    onEndContact(body) {
    }

    /**
     * @param {!number} trackIndex
     * @param {!number} loopCount
     */
    onAnimationComplete(trackIndex, loopCount) {
        const animationName = this.spine.state.tracks[0].animation.name;

        if (this._idleAnimationNames.indexOf(animationName) > -1 ||
            this._topAnimationNames.indexOf(animationName) > -1 ||
            this._hitAnimationNames.indexOf(animationName) > -1 ||
            this._landAnimationNames.indexOf(animationName) > -1) {
            this._hit = false;

            this.playIdleState(this.onTop);
        }
    }
}
